/* eslint-disable */
<template>
  <div class="BookingRequest">
    <Navigation indexProps="2" />
    <div class="top-panel">
      <Header />
      <div class="header-title-section">
        <div class="header-title"><h1>Booking Request</h1></div>
        <div class="header-sub-title">We look forward to helping you arrange the service you require for your claimant. Complete the form below, so we can assist you in finding the right specialist for your needs.</div>
      </div>
    </div>
    <div class="panel">
      <SpecialistMenu indexProps="0" />
      <div class="content">
        <div v-if="showCaseInfo" style="padding-left: 10px;">
          <span class="text-bold">Examinee:</span> {{ singleCase.claimantFullName }} <span class="text-bold"> D.O.B:</span> {{ formatDate(singleCase.dateOfBirth, "DD/MM/YYYY") }}
          <span class="text-bold"> Referral Type:</span> {{getClaimType(singleCase.claimTypeId)}}
        </div>
        <div class="box booking-details">
          <div class="box-heading col-space-between">
            <div>Booking details</div>
          </div>
          <div class="box-body">
            <div class="box-row">
              <div class="box-col box-col-left required">Service Type</div>
              <div class="box-col box-col-right">
                <div>
                  <el-select @change="onChangeBookingType" popper-class="search-specialty-popup" placeholder="Please choose" class="w-50" :class="hasError && bookingTypeError ? 'is-invalid' : ''" v-model="bookingRequest.bookingTypeId">
                    <el-option v-for="(bookingType, index) in bookingTypes" :key="bookingType.id" :value="bookingType.id" :label="bookingType.name">{{ bookingType.name }}</el-option>
                  </el-select>
                  <span class="ml-3" style="color: #3FA2F7; cursor: pointer" @click="getTPDPopup" v-if="isTPD">What's TPD Assist?</span>
                </div>
                <div v-if="hasError && bookingTypeError" class="text-danger">{{ bookingTypeError }}</div>
              </div>
            </div>
            <div class="box-row" v-if="!showCaseInfo">
              <div class="box-col box-col-left required">Referral Type</div>
              <div class="box-col box-col-right">
                <el-select  :disabled="isTPD" popper-class="search-specialty-popup" placeholder="Please choose type of claim..."  class="w-50" v-model="bookingRequest.claimTypeId" :class="hasError && claimTypeError ? 'is-invalid' : ''">
                  <el-option v-for="claimType in claimTypes" :key="claimType.id" :label="claimType.name" :value="claimType.id">{{ claimType.name }}</el-option>
                </el-select>
                <div v-if="hasError && claimTypeError" class="text-danger">{{ claimTypeError }}</div>
              </div>
            </div>
            <div class="box-row">
              <div class="box-col box-col-left">Choose Specialist</div>
              <div class="box-col box-col-right">
                <el-select filterable popper-class="search-specialty-popup" class="w-50" v-model="bookingRequest.specialistId" placeholder="Please choose (optional)" @change="changeSpecialist">
                  <el-option v-for="(specialist, index) in specialists" :key="specialist.id" :value="specialist.id" :label="specialist.fullName">{{ specialist.fullName }}</el-option>
                </el-select>
              </div>
            </div>
            <div class="box-row" >
              <div class="box-col box-col-left required">Reference Number</div>
              <div class="box-col box-col-right">
                <input class="textbox" type="text"
                       :class="hasError && clientReferenceError ? 'is-invalid' : ''"
                       v-model="bookingRequest.ClientReference"
                       placeholder="Reference Number"
                       maxlength="64"
                       @blur="trimField('ClientReference')" />
                <div v-if="hasError && clientReferenceError" class="text-danger">{{ clientReferenceError }}</div>
              </div>
            </div>
            <div class="box-row" >
              <div  class="box-col box-col-left required">State where the incident occurred</div>
              <div class="box-col box-col-right">
                <el-select v-model="bookingRequest.IncidentState" :class="hasError && incidentStateError ? 'is-invalid' : ''">
                  <el-option v-for="state in statesNew" :key="state.value" :value="state.value" :label="state.text">{{ state.text }}</el-option>
                </el-select>
                <div v-if="hasError && incidentStateError" class="text-danger">{{ incidentStateError }}</div>
              </div>
            </div>
            <div class="box-row" v-if="isTPD" >
              <div class="box-col box-col-left required">Number of services</div>
              <div class="box-col box-col-right">
                <el-checkbox v-model="showMAS" @change="onChangeNum('MAS', $event)" class="default-checkbox tick">MAS</el-checkbox> <el-input-number v-show="showMAS" :controls="false" style="width: 50px" v-model="bookingRequest.MAS" controls-position="right" :min="1" step-strictly :max="10"></el-input-number>
                <el-checkbox v-model="showPIC" @change="onChangeNum('PIC', $event)" class="default-checkbox tick">PIC</el-checkbox> <el-input-number v-show="showPIC" :controls="false" style="width: 50px"  v-model="bookingRequest.PIC" controls-position="right" :min="1" step-strictly :max="10"></el-input-number>
                <el-checkbox v-model="showSHORT" @change="onChangeNum('ShortReport', $event)" class="default-checkbox tick">Short Report</el-checkbox> <el-input-number v-show="showSHORT" :controls="false" style="width: 50px"  v-model="bookingRequest.ShortReport" controls-position="right" step-strictly :min="1" :max="10"></el-input-number>
                <div v-if="hasError && numOfServicesError" class="text-danger pl-2">{{ numOfServicesError }}</div>
              </div>
            </div>
            <div class="box-row" :class="disableCaseField ? 'disabled-element' : ''">
              <div class="box-col box-col-left required">Examinee</div>
              <div class="box-col box-col-right">
                <div v-if="!isEditName" @click="openAddNameModal" class="hidden-opacity-element is-icon full-width-div">
                </div>
                <span v-else class="padding-left-10" @click="openAddNameModal">
                  {{ bookingRequest.claimantFullName }}
                </span>
                <div class="text-danger" v-if="hasError && claimantNameErrors" style="position: absolute; z-index: 1; top: 30px;">
                  {{ claimantNameErrors }}
                </div>
              </div>
              <AddNameModal ref="addNameModal" @setName="setName" />
            </div>
            <div class="box-row" v-if="!showCaseInfo" :class="disableCaseField ? 'disabled-element' : ''">
              <div class="box-col box-col-left" :class="!disableCaseField ? 'required' : ''">Date of Birth</div>
              <div class="box-col box-col-right box-col-center">
                <datepicker :disabled="disableCaseField" v-model="bookingRequest.dateOfBirth" format="dd/MM/yyyy" :typeable="true" class="w-50" placeholder="dd/mm/yyyy" :input-class="hasError && dateOfBirthError ? 'textbox is-invalid' : 'textbox'"></datepicker>
                <div v-if="hasError && dateOfBirthError" class="text-danger">{{ dateOfBirthError }}</div>
              </div>
            </div>
            <div class="box-row">
              <div class="box-col box-col-left">Affected Body Areas</div>
              <div class="box-col box-col-right box-col-center">
                <vue-tags-input
                  v-model="bodyAreaTag"
                  :tags="bodyAreaTags"
                  placeholder="Add Affected Body Areas"
                  :autocomplete-items="filteredBodyAreaItems"
                  @tags-changed="(newTags) => (bodyAreaTags = newTags)"
                  @focus="openDigram()"
                />
              </div>
              <div @click="openBodyDiagram" class="center-item">
                <img src="@/assets/images/choose.svg" alt="" class="right-element align-self-center is-icon pr-3"/>
              </div>
              <AddBodyDiagramModal style="top: 0px" ref="addBodyDiagramModal" />
            </div>
            <div class="box-row">
              <div class="box-col box-col-left">Other Body Areas</div>
              <div class="box-col box-col-right box-col-center">
                <vue-tags-input
                    v-model="otherBodyAreaTag"
                    :tags="otherBodyAreaTags"
                    placeholder="Add Other Body Areas"
                    @tags-changed="(newTags) => (otherBodyAreaTags = newTags)" />
                <div v-if="hasError && otherBodyAreasError" class="text-danger">{{ otherBodyAreasError }}</div>
              </div>
            </div>
            <div class="box-row">
              <div class="box-col box-col-left">Conditions</div>
              <div class="box-col box-col-right box-col-center">
                <el-select  placeholder="Add Conditions" class="w-100" v-model="bookingRequest.PersonConditions" multiple clearable filterable>
                  <el-option v-for="item in personConditions" :value="item.value" :label="item.text" :key="item.value"></el-option>
                </el-select>
              </div>
            </div>
            <div v-if="!isTPD" class="box-row">
              <div class="box-col box-col-left required">Choose Region / Location</div>
              <div class="box-col box-col-right" >
                <el-cascader
                    popper-class="search-no-scroll-panel"
                    class="w-50"
                    :options="regionLocations"
                    :value="locationValue"
                    @change="changeRegion"
                    :props="{ checkStrictly: true, value: 'id', label: 'label' }"
                    clearable>
                </el-cascader>
                <div v-if="hasError && locationError" class="text-danger">{{ locationError }}</div>
              </div>
            </div>
            <div v-if="!isTPD" class="box-row">
              <div class="box-col box-col-left">Specify Date Range</div>
              <div class="box-col box-col-right">
                <v-md-date-range-picker :start-date="bookingRequest.dateFrom" :end-date="bookingRequest.dateTo" @change="changeDateRange"></v-md-date-range-picker>
                <div class="text-danger" v-if="hasError && dateRangeError">
                  {{ dateRangeError }}
                </div>
              </div>
            </div>
            <div class="box-row" v-if="showDelivery" >
              <div class="box-col box-col-left required">Delivery Method</div>
              <div class="box-col box-col-right">
                <el-select filterable multiple clearable placeholder="Select delivery method"
                           class="w-50" :class="hasError && deliveryMethodError ? 'is-invalid' : ''" v-model="bookingRequest.deliveryMethod">
                  <el-option :value="2" label="Virtual"
                             title="This service will be delivered by videolink only."></el-option>
                  <el-option :value="1" label="In-Person"
                             title="This service will be delivered face to face with the Medical Expert"></el-option>
                </el-select>
                <div class="text-danger" v-if="hasError && deliveryMethodError">
                  {{ deliveryMethodError }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="box">
          <div class="box-heading tab">
            <div class="tab-heading px-5  notes-heading tab-selected" @click="openNotes">Notes</div>
            <div class="tab-heading px-5 files-heading" @click="openFiles">Files</div>
            <div v-if="hasError && noteError" class="text-danger w-100 pl-3">{{ noteError }}</div>
            <div class="col-space-between is-icon right-float-element">
              <v-btn v-if="showAddNote" class="add-icon mr-3" dark @click="openAddNoteModal">Add New</v-btn>
              <v-btn v-if="!showAddNote && !isTPD" class="add-icon mr-3" dark @click="openFilesBox">Add New</v-btn>
              <AddNoteModal ref="addNoteModal" :bookingProps="booking" />
            </div>
          </div>
          <div class="box-body notes-content hidden-element">
            <div class="box-row">
              <div class="box-col box-col-left">{{ bookingRequest.note != '' ? user.name : '' }}</div>
              <div class="box-col box-col-left">{{ bookingRequest.note != '' ? getDate() : '' }}</div>
              <div @click="editNote()" style="max-width: 60%" class="box-col box-col-right box-col-long col-center-content">
                {{ bookingRequest.note }}
              </div>
            </div>
          </div>
          <div class="box-body files-content hidden-element">
            <div>
              <div>
                <table class="table">
                  <thead>
                    <tr>
                      <th style="width:20%" class="long-text">
                        File Type
                      </th>
                      <th style="width:40%" class="long-text">
                        File Name
                      </th>
                      <th style="width:20%" class="long-text">
                        Uploaded By
                      </th>
                      <th style="width:12%" class="long-text">
                        Status
                      </th>
                      <th style="width:8%" class="icon-col"><div class="icon-group">&nbsp;</div></th>
                    </tr>
                  </thead>
                </table>
              </div>
              <div class="content-scroll-y" style="height:auto;max-height:460px;">
                <table class="table remove-min-height">
                  <tbody>
                    <tr v-for="(file, index) in fileParams" :key="index" class="py-0">
                      <td style="width:20%" class="long-text">
                        <el-select v-model="file.FileTypeID" :disabled="isTPD">
                          <el-option v-for="fileType in fileTypes" :value="fileType.FileTypeID" :disabled="fileType.FileTypeID ===11 || fileType.FileTypeID ===12" :key="fileType.FileTypeID" :label="fileType.FileTypeName">{{ fileType.FileTypeName }}</el-option>
                        </el-select>
                      </td>
                      <td style="width:40%" class="long-text">{{file.FileName}}</td>
                      <td style="width:20%" class="long-text">{{file.UploadedByName}}</td>
                      <td style="width:12%" class="long-text">
                        <span style="padding-left: 10px;">{{file.FileStatus ? 'Final' : 'Draft'}}</span>
                      </td>
                      <td style="width:8%" @click="deleteFile(index)" class="long-text"><img src="@/assets/images/delete_icon.svg" /></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div v-if="!isTPD" class="file-upload-area border-gray-300 mt-5" @dragover="dragover" @dragleave="dragleave" @drop="drop">
              <input
                type="file"
                multiple
                name="fields[assetsFieldHandle][]"
                id="assetsFieldHandle"
                class="w-px h-px opacity-0 overflow-hidden absolute"
                @change="onChange"
                ref="file"
                accept="" />
              <label for="assetsFieldHandle" class="block cursor-pointer d-flex justify-content-center flex-column align-items-center">
                <div>Drop files in this area or <span style="text-decoration:underline" class="is-icon">click here</span> to upload files.</div>
                <div>Files over 200MB in file size may cause errors. If you need to upload files of this size, please contact us on 1300 100 733</div>
              </label>
            </div>
          </div>
        </div>
        <div class="alert alert-success hidden-element">
          <a class="close" title="close">×</a>
          <b>Success:</b> {{ successMessage }}
        </div>
        <div class="alert alert-danger hidden-element">
          <a class="close" title="close">×</a>
          <b>Error:</b> {{ errorMessage }}
        </div>
        <div class="box-row item-right box-col-next">
          <div><v-btn dark @click="tapSubmit()">Submit</v-btn></div>
        </div>
      </div>
    </div>
    <el-dialog title="Information about TPD Assist" :visible.sync="tpdList">
      <div class="mt-2" style="word-break: break-word"  v-html="tpdList && tpdList.Message">
      </div>
      <span slot="footer" class="dialog-footer">
    <el-button type="primary" @click="cancelTPDModal">OK</el-button>
  </span>
    </el-dialog>
    <Chat />
    <TPDFiles :client="true" :fileCountList="fileCountList" :tpdFilesDialog="tpdFilesDialog" @cancelDialog="tpdFilesDialog = false" @next="handleFiles" />
  </div>
</template>

<script>
  import utilities from '@/assets/js/utilities'
  import Navigation from '@/components/Navigation'
  import SpecialistMenu from '@/components/SpecialistMenu'
  import Header from '@/components/Header'
  import Chat from '@/components/Chat'
  import AddNoteModal from '@/components/AddNoteModal'
  import AddNameModal from '@/components/AddNameModal'
  import AddBodyDiagramModal from '@/components/AddBodyDiagramModal'
  import TPDFiles from "./TPDFiles.vue";

  export default {
    name: 'BookingRequest',
    components: {
      TPDFiles,
      Navigation,
      SpecialistMenu,
      Header,
      Chat,
      AddNoteModal,
      AddNameModal,
      AddBodyDiagramModal,
    },
    data() {
      return {
        statesNew: utilities.getStates(),
        fileCountList: [0, 0, 0, 0],
        tpdFilesDialog: false,
        showSHORT: false,
        showMAS: false,
        showPIC: false,
        tpdList: null,
        locationValue: null,
        valueDate: [],
        otherBodyAreaTags: [],
        otherBodyAreaTag: "",
        hasError: false,
        isHideSpecialty: false,
        clickSpecialty: false,
        clickSpecialist: false,
        clickBookingType: false,
        clickClaimType: false,
        showCaseInfo: false,
        isEditName: false,
        showDelivery: false,
        showAddNote: true,
        disableCaseField: false,
        pagination: utilities.initPagination(),
        booking: utilities.initBooking(),
        bookingRequest: utilities.initBookingRequest(),
        singleCase: utilities.initCase(),
        specialtyId: '',
        specialistId: '',
        bodyAreas: [],
        bodyAreaTag: '',
        bodyAreaTags: [],
        personConditions: [],
        personConditionTag: '',
        personConditionTags: [],
        specialists: [],
        qualifications: [],
        bookingTypes: [],
        regions: [],
        locations: [],
        filelist: [],
        claimTypes: [],
        regionLocations: [],
        noteKey: 0,
        nameKey: 0,
        successMessage: '',
        errorMessage: '',
        placeholder: 'Add',
        fileTypes: [],
        SpecialistBookingTypes: utilities.getSearchSpecialistsBookingTypes(),
        fileParams: [],
      }
    },
    computed: {
      user() {
        return this.$store.getters['user/getUser'];
      },
      isTPD() {
        return this.bookingRequest.bookingTypeId === 19
      },
      bookingTypeError() {
        if (this.bookingRequest.bookingTypeId === '' || this.bookingRequest.bookingTypeId === null || this.bookingRequest.bookingTypeId === undefined) {
          return 'Service type is required.'
        }
        return ''
      },
      claimTypeError() {
        if (this.showCaseInfo) {
          return ''
        }
        if (this.bookingRequest.claimTypeId === '' || this.bookingRequest.claimTypeId === null || this.bookingRequest.claimTypeId === undefined) {
          return 'Referral type is required.'
        }
        return ''
      },
      clientReferenceError() {
        return utilities.getBookingRequestReferenceError(this.bookingRequest.ClientReference)
      },
      incidentStateError() {
        if (!this.bookingRequest.IncidentState || String(this.bookingRequest.IncidentState).trim() === '') {
          return 'State where the incident occurred is required.'
        }
        return ''
      },
      claimantNameErrors() {
        return [
          utilities.getClientContactPersonNameError(this.bookingRequest.claimantFirstName, 'First name'),
          utilities.getClientContactMiddleNameError(this.bookingRequest.claimantGivenNames),
          utilities.getClientContactPersonNameError(this.bookingRequest.claimantSurname, 'Surname'),
        ].filter(Boolean).join(' ')
      },
      dateOfBirthError() {
        if (this.showCaseInfo || this.disableCaseField) {
          return ''
        }
        if (this.bookingRequest.dateOfBirth === '' || this.bookingRequest.dateOfBirth === null || this.bookingRequest.dateOfBirth === undefined) {
          return 'Date of birth is required.'
        }
        return ''
      },
      locationError() {
        if (this.isTPD) {
          return ''
        }
        if (!this.bookingRequest.regionId && !this.bookingRequest.stateId) {
          return 'Region / location is required.'
        }
        return ''
      },
      /** Optional; error only if one of start/end is set without the other. */
      dateRangeError() {
        if (this.isTPD) {
          return ''
        }
        const df = this.bookingRequest.dateFrom
        const dt = this.bookingRequest.dateTo
        if (!df && !dt) {
          return ''
        }
        if (df && dt) {
          return ''
        }
        return 'Please specify a complete date range (start and end).'
      },
      numOfServicesError() {
        if (!this.isTPD) {
          return ''
        }
        if (!this.showSHORT && !this.showMAS && !this.showPIC) {
          return 'Please select at least one service type (MAS, PIC, or Short Report) and enter a number.'
        }
        if ((this.showSHORT && !this.bookingRequest.ShortReport) || (this.showMAS && !this.bookingRequest.MAS) || (this.showPIC && !this.bookingRequest.PIC)) {
          return 'Please enter a number (1–10) for each selected service type.'
        }
        return ''
      },
      deliveryMethodError() {
        if (!this.showDelivery) {
          return ''
        }
        const dm = this.bookingRequest.deliveryMethod
        if (!dm || (Array.isArray(dm) && dm.length === 0)) {
          return 'Please select at least one delivery method.'
        }
        return ''
      },
      noteError() {
        return utilities.getBookingRequestNoteError(this.bookingRequest.note)
      },
      otherBodyAreasError() {
        return utilities.getBookingRequestOtherBodyAreasError(this.otherBodyAreaTags)
      },
      filteredBodyAreaItems() {
        return this.bodyAreas.filter((i) => {
          return i.text.toLowerCase().indexOf(this.bodyAreaTag.toLowerCase()) !== -1
        })
      },

      filteredPersonConditionsItems() {
        return this.personConditions.filter((i) => {
          return i.text.toLowerCase().indexOf(this.personConditionTag.toLowerCase()) !== -1
        })
      },

    },

    methods: {
      checkValidFilesForTPD() {
        const fileTypes = ['MAS Template', 'PIC Template', 'Letter of Instruction', 'Brief']
        const fileCounts = [this.showMAS ? this.bookingRequest.MAS : 0, this.showPIC ?this.bookingRequest.PIC : 0, this.showSHORT ? this.bookingRequest.ShortReport : 0, 1]
        let valid = true
        fileTypes.forEach((file, i) => {
          const id = this.fileTypes.find((x) => x.FileTypeName === file).FileTypeID
          const filter = this.fileParams.filter(x => x.FileTypeID === id)
          if(filter.length < fileCounts[i] && file !== 'Brief') {
            this.fileCountList[i] = fileCounts[i] - filter.length
            valid = false
          } else if (file === 'Brief' && filter.length === 0) {
            this.fileCountList[i] = 1
            valid = false
          } else {
            this.fileCountList[i] = 0
          }
        })
        return valid
      },
      handleFiles(files) {
        this.tpdFilesDialog = false
        this.openFiles()
        //this.booking.bookingFiles = []
        var i = 0
        const fileTypes = ['MAS Template', 'PIC Template', 'Letter of Instruction', 'Brief']
        files.map((e, index) => {
          e && e.forEach((x) => {
            let file = this.fileParams.filter((y) => y.FileName === x.name)
            if (file.length === 0) {
              this.fileParams.push({
                FileName: x.name,
                FileTypeID: this.fileTypes.find((x) => x.FileTypeName === fileTypes[index]).FileTypeID,
                UploadedBy: this.user.id,
                MimeType: x.type,
                FileStatus: 1,
                UploadedByName: this.user.name,
                DateUploaded: window.moment().format("YYYY-MM-DD HH:mm:ss"),
                isHide: false,
                index: i,
                file: x
              })
            }
          })
        })
      },
      onChangeNum(name, value) {
        if (value) {
          this.bookingRequest[name] = 1
          this.$set(this.bookingRequest, name, 1)
        } else {
          this.$set(this.bookingRequest, name, 0)
        }
      },
      cancelTPDModal() {
        this.tpdList = null
      },
      confirmTPDModal() {
        this.tpdList = null;
        this.tapSubmit(true)
      },
      onChangeBookingType() {
        this.showDelivery = utilities.bookingTypeWithDeliveryMethods(this.bookingRequest.bookingTypeId)
        if(this.bookingRequest.bookingTypeId === 19) {
          this.bookingRequest.claimTypeId = 3
          this.getTPDPopup()
        } else {
          this.bookingRequest.claimTypeId = null
        }
      },

      getTPDPopup() {
        this.$store.dispatch('loading/setLoadComponent', true)
        utilities.getTPDPopUp().then(res => {
          this.tpdList = res
          this.$store.dispatch('loading/setLoadComponent', false)
        })
      },
      updateConditions(newTags) {
        if(this.$refs.conditions.newTag.length == 0) newTags.pop()
        this.personConditionTags = newTags
      },

      openDigram() {
        this.openBodyDiagram()
      },

      openAddNameModal() {
        if (this.disableCaseField) {
          return
        }

        if (this.isEditName) {
          this.$refs.addNameModal.editFullName(this.bookingRequest.claimantFirstName, this.bookingRequest.claimantGivenNames, this.bookingRequest.claimantSurname)
        }
        this.$refs.addNameModal.handleModal();
      },

      openBodyDiagram() {
        this.$refs.addBodyDiagramModal.handleModal()
        this.$refs.addBodyDiagramModal.filteredBodyAreas = this.bodyAreas
        this.$refs.addBodyDiagramModal.bodyAreas = _.cloneDeep(this.bodyAreaTags)
        this.$refs.addBodyDiagramModal.handleClick()
      },

      deleteBodyAreaItems() {},

      setBodyArea(addedBodyAreas) {
        this.bodyAreaTags = []
        this.bodyAreaTags = addedBodyAreas
      },

      setName(object) {
        this.bookingRequest.claimantFirstName = object.firstName
        this.bookingRequest.claimantGivenNames = object.middleName
        this.bookingRequest.claimantSurname = object.surname
        this.bookingRequest.claimantFullName = utilities.getClaimantFullName(this.bookingRequest)
        this.isEditName = true
        this.$forceUpdate()
      },

      changeSpecialty(event) {
        this.bookingRequest.specialistId = ""
        this.clickSpecialist = false
      },

      changeSpecialist(event) {
        this.specialtyId = ""
        this.clickSpecialty = false
      },

      sanitizeBookingRequest() {
        this.bookingRequest.ClientReference = String(this.bookingRequest.ClientReference || '').trim()
        this.bookingRequest.claimantFirstName = String(this.bookingRequest.claimantFirstName || '').trim()
        this.bookingRequest.claimantGivenNames = String(this.bookingRequest.claimantGivenNames || '').trim()
        this.bookingRequest.claimantSurname = String(this.bookingRequest.claimantSurname || '').trim()
        this.bookingRequest.note = String(this.bookingRequest.note || '').trim()
      },
      trimField(prop) {
        const v = this.bookingRequest[prop]
        if (v === undefined || v === null) {
          return
        }
        this.bookingRequest[prop] = String(v).trim()
      },
      async tapSubmit() {
        this.sanitizeBookingRequest()
        const validationErrors = [
          this.bookingTypeError,
          this.claimTypeError,
          this.clientReferenceError,
          this.incidentStateError,
          this.claimantNameErrors,
          this.dateOfBirthError,
          this.locationError,
          this.dateRangeError,
          this.noteError,
          this.otherBodyAreasError,
          this.numOfServicesError,
          this.deliveryMethodError,
        ].filter(Boolean)
        if (validationErrors.length > 0) {
          this.hasError = true
          this.errorMessage = 'Please correct the errors shown above and try again.'
          utilities.showAlert('.alert-danger')
          return
        }
        this.hasError = false

        if(this.isTPD && !this.checkValidFilesForTPD()) {
          this.$forceUpdate()
          this.tpdFilesDialog = true
          return
        }

        this.$store.dispatch('loading/setLoadComponent', true)

        var result = await this.postBookingRequest()
        //upload file into the booking
        if(result) {
          var params = {
            BookingRequestID: this.bookingRequest.id,
            UserID: this.user.id,
            Username: this.user.name,
            SubmittedBy: this.user.id,
            FileObject: [],
          }

          if(this.fileParams.length > 0) {
            await Promise.all(this.fileParams.map(async (x) => {
              if(this.bookingRequest.id != '') {
                var fileName = moment().unix() + '_' + x.FileName.replace(/\s/g, '_')
                const mimeType = await utilities.getFileMimeType(x.file, x.MimeType || 'application/octet-stream')
                var fileParams = {
                  fn: fileName,
                  ft: mimeType,
                  id: this.bookingRequest.id,
                  FileTypeID: x.FileTypeID,
                }
                var result = await utilities.postRequestPreSign(fileParams)
                var postData = new FormData();

                for(var key in result.fields){
                    postData.append(key, result.fields[key]);
                }
                postData.append('file', x.file)
                await utilities.postImage(result.url, postData)

                params.FileObject.push({
                  FileName: fileName,
                  FileTypeID: x.FileTypeID,
                  UploadedBy: this.user.id,
                  MimeType: mimeType,
                  DateUploaded: moment().format('YYYY-MM-DD HH:mm:ss'),
                  FileStatus: 0,
                  UploadedByName: this.user.name,
                  BookingRequestID: this.bookingRequest.id,
                })
              }
            }))
          }
          if(params.FileObject.length > 0) {
            var callback = (response) => {
            }
            await utilities.postRequestFileRecord(params.FileObject)
          }
          this.$notify({
            dangerouslyUseHTMLString: true,
            duration: 10000,
            message: '<div class="alert-success">' +
                "            <b>Success:</b> Thank you, we've received your request, and we'll look into it. You can track your requests in the Bookings and then Service Requests" +
                '          </div>',
          })
          this.bookingRequest = []
          this.bookingRequest = utilities.initBookingRequest()
          this.specialtyId = ''
          this.bodyAreaTags = []
          this.personConditionTags = []
          this.filelist = []
          this.fileParams = []
          this.hasError = false
          this.isEditName = false
          this.bookingRequest.dateFrom = moment().format('YYYY-MM-DD')
          this.bookingRequest.dateTo = moment().format('YYYY-MM-DD')
          this.$router.push({name: 'search-specialist'})
        }
        this.$store.dispatch('loading/setLoadComponent', false)
      },

      postBookingRequest() {
        var bodyAreaObjects = []
        var bodyArea = {}
        if (this.bodyAreaTags.length > 0 && !this.disableCaseField) {
          this.bodyAreaTags.map((x) => {
            bodyArea = {
              BodyAreaID: x.value,
            }
            bodyAreaObjects.push(bodyArea)
          })
        }

        var qualifications = []
        var qualification = {}
        if (this.specialtyId) {
          qualification = {
            QualificationID: this.specialtyId,
          }
          qualifications.push(qualification)
        }

        var params = {
          MAS: this.showMAS ? this.bookingRequest.MAS : 0,
          PIC: this.showPIC ? this.bookingRequest.PIC : 0,
          ShortReport: this.showSHORT ? this.bookingRequest.ShortReport : 0,
          CaseID: this.singleCase.id ? this.singleCase.id : undefined,
          ClientID: this.user.clientId,
          SpecialistID: this.bookingRequest.specialistId ? this.bookingRequest.specialistId : undefined,
          BookingTypeID: this.bookingRequest.bookingTypeId,
          ClaimTypeID: this.bookingRequest.claimTypeId,
          DateFrom: moment(this.bookingRequest.dateFrom).format('YYYY-MM-DD'),
          DateTo: moment(this.bookingRequest.dateTo).format('YYYY-MM-DD'),
          VideoLinkAccepted: utilities.convertBoolToNum(this.bookingRequest.videoLinkAccepted),
          BookingRequestStatus: 1,
          ClaimantFirstName: this.bookingRequest.claimantFirstName,
          ClaimantGivenNames: this.bookingRequest.claimantGivenNames,
          ClaimantSurname: this.bookingRequest.claimantSurname,
          DateofBirth: moment(this.bookingRequest.dateOfBirth).format('YYYY-MM-DD'),
          ClientReference: this.bookingRequest.ClientReference,
          IncidentState: this.bookingRequest.IncidentState,
          Notes: this.bookingRequest.note,
          BodyAreaObject: bodyAreaObjects,
          ConditionObject: this.bookingRequest.PersonConditions.map(item => {return {PersonConditionID: item}}),
          DateSubmitted: moment().format('YYYY-MM-DD HH:mm:ss'),
          DeliveryMethodIDs: this.bookingRequest.deliveryMethod ? this.bookingRequest.deliveryMethod : undefined,
        }
        if (this.bookingRequest.stateId && this.bookingRequest.stateId.includes('s')) {
          params.StateID = Number(this.bookingRequest.stateId.replace('s', ''))
        }
        if (this.bookingRequest.regionId && this.bookingRequest.regionId.includes('r')){
          params.RegionID = Number(this.bookingRequest.regionId.replace('r', ''))
        }
        if (this.singleCase.id) {
          params.DateofBirth = this.singleCase.dateOfBirth
          params.ClaimTypeID = this.singleCase.claimTypeId
        }

        let otherBodyArea = ""
        this.otherBodyAreaTags.map((x) => {
          if (otherBodyArea == "") {
            otherBodyArea = x.text
          } else {
            otherBodyArea = otherBodyArea + "," + x.text
          }
        })
        params.BodyAreaOther = otherBodyArea

        var callback = (response) => {
          this.bookingRequest.id = response
        }
        return utilities.postBookingRequest(params, callback)
      },

      getDate() {
        return moment().format('DD/MM/YYYY HH:mm')
      },

      openNotes() {
        this.showAddNote = true
        $('.notes-content').show()
        $('.tab-selected').removeClass('tab-selected')
        $('.notes-heading').addClass('tab-selected')
        $('.files-content').hide()
      },

      openFiles() {
        this.showAddNote = false
        $('.notes-content').hide()
        $('.tab-selected').removeClass('tab-selected')
        $('.files-heading').addClass('tab-selected')
        $('.files-content').show()
      },

      addNoteToBooking(note) {
        this.bookingRequest.note = note
        this.openNotes()
      },

      editNote() {
        this.$refs.addNoteModal.editCurrentNote(this.bookingRequest.note, true)
        this.$refs.addNoteModal.handleModal()
      },

      handleClickSpecialty() {
        this.clickSpecialty = true
        this.isHideSpecialty = false
        // this.clickSpecialist = false
        // this.bookingRequest.specialistId = ''
      },

      handleClickSpecialist() {
        this.clickSpecialist = true
        this.isHideSpecialty = true
        // this.clickSpecialty = false
        // this.specialtyId = ''
      },

      handleClickBookingType() {
        this.clickBookingType = true
      },

      changeRegion(item) {
        if (item && item.length > 0) {
          this.bookingRequest.stateId = item[0]
          if (item.length > 1) {
            this.bookingRequest.regionId = item[1]
          }
        } else {
          this.bookingRequest.regionId = null;
          this.bookingRequest.stateId = null
        }
      },

      changeDateRange(item) {
        this.bookingRequest.dateFrom = utilities.formatDate(item[0])
        this.bookingRequest.dateTo = utilities.formatDate(item[1])
      },

      formatDate(date, format = "YYYY-MM-DD", currentFormat = "YYYY-MM-DD") {
        return utilities.formatDate(date, format, currentFormat)
      },

      getClaimType(id) {
        var type = ''
        this.claimTypes.forEach((item) => {
          if (item.id == id) {
            type = item.name
          }
        })
        return type
      },

      openAddNoteModal(e) {
        this.$refs.addNoteModal.addNoteToBooking()
        this.$refs.addNoteModal.handleModal()
      },

      openFilesBox() {
        $('#assetsFieldHandle').trigger('click')
      },

      async onChange() {
        this.$store.dispatch('loading/setLoadComponent', true)
        this.filelist = [...this.$refs.file.files]
        if(this.filelist.length > 0) {
          await Promise.all(this.filelist.map(async (x) => {
            var params = {
              FileName: x.name.replace(/\s/g, '_'),
              FileTypeID: 2, //'Letter of Instruction'
              MimeType: x.type,
              FileStatus: 0,
              file: x
            }
            this.fileParams.push(params)
          }))
        }
        this.$store.dispatch('loading/setLoadComponent', false)
      },

      remove(i) {
        this.filelist.splice(i, 1)
      },
      dragover(event) {
        event.preventDefault()
        // Add some visual fluff to show the user can drop its files
        // if (!event.currentTarget.classList.contains('bg-green-300')) {
        //   event.currentTarget.classList.remove('bg-gray-100')
        //   event.currentTarget.classList.add('bg-green-300')
        // }
        event.currentTarget.classList.add('dark-border-hover')
      },
      dragleave(event) {
        // Clean up
        // event.currentTarget.classList.add('bg-gray-100')
        // event.currentTarget.classList.remove('bg-green-300')
        event.currentTarget.classList.remove('dark-border-hover')
      },
      drop(event) {
        event.preventDefault()
        this.$refs.file.files = event.dataTransfer.files
        this.onChange() // Trigger the onChange event manually
        // Clean up
        event.currentTarget.classList.add('bg-gray-100')
        event.currentTarget.classList.remove('bg-green-300')
        event.currentTarget.classList.remove('dark-border-hover')
      },

      async deleteNote(id, index) {
        if (confirm('Are you sure you want to delete this note?')) {
          // var temp = _.cloneDeep(this.booking.bookingNotes)
          // this.booking.bookingNotes = temp.splice(0, index).concat(temp.splice(index + 1, temp.length - 1))
        }
      },

      async getLocationData() {
        var locations = await utilities.getLocations()
        var groupedLocations = []
        locations.map((x) => {
          if (groupedLocations[x.regionId] == undefined) {
            groupedLocations[x.regionId] = []
          }
          groupedLocations[x.regionId].push(x)
        })
        var tempLocations = []
        groupedLocations.map((x) => {
          var obj = {
            id: 'r' + x[0].regionId,
            label: x[0].regionName,
          }
          var children = []
          for (var i = 0; i < x.length; i++) {
            children.push({
              id: 'c' + x[i].cityId,
              label: x[i].cityName,
            })
          }
          children = _.uniqBy(children, 'label')
          obj.children = children
          tempLocations.push(obj)
        })
        this.locations = tempLocations
      },

      setLastSearchIngo(searchLogs) {
        if (searchLogs.dateStart != '' && this.bookingRequest.dateTo != '') {
          this.bookingRequest.dateFrom = moment(searchLogs.dateStart).format('YYYY-MM-DD')
          this.bookingRequest.dateTo = moment(searchLogs.dateEnd).format('YYYY-MM-DD')
        }
        this.bookingRequest.videoLinkAccepted = searchLogs.videoLinkAccepted == 1 ? true : false
        this.bookingRequest.specialistId

        if (searchLogs.qualifications.length > 0) {
          var qualification = this.qualifications.find((x)=> x.name == searchLogs.qualifications[0].qualificationName)
          this.specialtyId = qualification.id
          this.bookingRequest.specialistId = ""
          this.clickSpecialty = true
          this.clickSpecialist = false
        } else {
          this.clickSpecialist = true
          this.clickSpecialty = false
          this.bookingRequest.specialistId = searchLogs.specialistId
          this.specialtyId = ""
        }

        if (this.specialistId != '') {
          this.specialtyId = ""
          this.bookingRequest.specialistId = this.specialistId
          this.clickSpecialist = true
        }

        if (searchLogs.cities.length > 0) {
          var city = this.locations.find((x)=> x.cityName == searchLogs.cities[0].cityName)
          var region = this.regionLocations.find((x) => x.id == 'r'+city.regionId)
          if (region != undefined) {
            var selectedCity = region.children.find((x) => x.id == 'c'+city.cityId)
            if (selectedCity != undefined) {
              this.$refs.treeSelect.select(selectedCity)
            }
          }
        }

        var typeName = this.SpecialistBookingTypes.find((x) => x.id == searchLogs.specialistServiceName).name
        var bookingTypeId = this.bookingTypes.find((x) => x.name == typeName).id
        this.bookingRequest.bookingTypeId = bookingTypeId
        this.clickBookingType = true
      },

      showClientBookingTypes() {
        var temp = []
        this.bookingTypes.forEach((x) =>{
          if (x.settings.Client.AllowBookingRequest) {
            temp.push(x)
          }
        })

        this.bookingTypes = temp
      },

      setCaseInfo(){
        this.bookingRequest.claimantFirstName = this.singleCase.claimantFirstName
        this.bookingRequest.claimantGivenNames = this.singleCase.claimantGivenNames
        this.bookingRequest.claimantSurname = this.singleCase.claimantSurname
        this.bookingRequest.claimantFullName = this.singleCase.claimantFullName
        if (this.bookingRequest.claimantFullName != "") {
          this.isEditName = true
        }

        // if (this.singleCase.bodyAreas.length > 0) {
        //   this.bodyAreaTags = utilities.getAutoCompleteBodyAreaTags(this.singleCase.bodyAreas)
        // }
        //
        // if (this.singleCase.personCondition.length > 0) {
        //   this.personConditionTags = utilities.getAutoCompleteTags(this.singleCase.personCondition)
        // }

        this.disableCaseField = true
      },

      async loadData(caseId) {
        this.$store.dispatch('loading/setLoadComponent', true)
        if (caseId != '') {
          this.singleCase = await utilities.getCaseByCaseId(caseId)
          this.showCaseInfo = true
          this.setCaseInfo()
        } else {
          this.showCaseInfo = false
        }
        const apiArr = [utilities.getBodyArea(), utilities.getPersonConditions(),utilities.getSpecialists(),utilities.getQualifications(),utilities.getRegions(),utilities.getLocations(),utilities.getBookingTypes(),utilities.getClaimTypes()]
        const res = await Promise.all(apiArr)
        let bodyAreas = res[0]
        this.bodyAreas = utilities.getAutoCompleteBodyAreaTags(bodyAreas)
        let personConditions = res[1]
        this.personConditions = utilities.getAutoCompleteTagsUpperCase(personConditions)
        this.specialists = res[2]
        this.qualifications = res[3]
        this.regions = res[4]
        this.locations = res[5]
        this.regionLocations = utilities.getRegionLocations(this.regions, this.locations, true)
        this.bookingTypes = res[6]
        this.showClientBookingTypes()
        this.claimTypes = res[7]

        let isEmpty = this.$route.query.isEmpty != undefined ? this.$route.query.isEmpty : false

        var types = await utilities.getFileTypes()
        types.map((x) => {
          if (x.FileTypeName == 'Brief' || x.FileTypeName == 'Letter of Instruction' || x.FileTypeName == 'Other' || x.FileTypeName == 'MAS Template' || x.FileTypeName == 'PIC Template') {
            this.fileTypes.push(x)
          }
        })

        this.$store.dispatch('loading/setLoadComponent', false)
      },
      deleteFile(index) {
        this.fileParams.splice(index, 1)
      }
    },

    async beforeMount() {
      this.bookingRequest.dateFrom = moment().format('YYYY-MM-DD')
      this.bookingRequest.dateTo = moment().format('YYYY-MM-DD')

      this.singleCase.id = this.$route.query.id != undefined ? this.$route.query.id : ''
      this.specialistId = this.$route.query.spId != undefined ? this.$route.query.spId : ''
      await this.loadData(this.singleCase.id)
      this.booking.bookingNotes.push(utilities.initBookingNote())
    },

    mounted() {
      window.scrollTo({ top: 0, behavior: 'smooth' })
      $('[data-toggle="tooltip"]').tooltip()
    },
  }
</script>

<style scoped>
.search-popup-longer .el-select-dropdown__wrap {
  max-height: 330px;
}
.default-checkbox.tick {
  margin-left: 20px;
  margin-right: 20px;
  height: 40px;
}
::v-deep .el-input-number .el-input__inner {
  padding-left: 0 !important;
  padding-right: 0 !important;
}
</style>
